export const API_SUCCESS = 'API_SUCCESS';
export const LOADING = 'LOADING';
export const SEARCHVEHICLEANDCHASSISLOADED = 'SEARCHVEHICLEANDCHASSISLOADED';